"use strict";
exports.__esModule = true;
var broadcast_message_1 = require("../logic/broadcast-message");
function BroadcastMessageContrller($scope, $cookies, $timeout) {
    var ctrl = this;
    ctrl.isActive = false;
    ctrl.initialStartDate;
    ctrl.initalEndDate;
    ctrl.isLoading = true;
    ctrl.isFormLoadading = false;
    ctrl.$onInit = function () { };
    var SUCCESS_MESSAGE = 'success';
    var ERROR_MESSAGE = 'danger';
    var MESSAGE_COOKIE_KEY = 'read_messages';
    function showAlert(type, title, message) {
        if (ctrl.showAlert) {
            ctrl.showAlert({ type: type, title: title, message: message });
        }
        else {
            alert(title + '\n' + message);
        }
    }
    ctrl.searchKey = '';
    ctrl.messages = {
        list: [],
        selected: undefined
    };
    ctrl.group = {
        list: []
    };
    ctrl.currentMessage = new broadcast_message_1["default"](ctrl.group.list);
    ctrl.messageFilter = function (item) {
        return item.title.toLowerCase().indexOf(ctrl.searchKey.toLowerCase()) >= 0;
    };
    $scope.$on('manage:BROADCAST_MESSAGE_MANAGE', function (event, args) {
        resetCurrentMessage();
        initData();
    });
    ctrl.updateValidator = function () {
        var startDate = new Date(ctrl.currentMessage.startDate);
        startDate.setDate(startDate.getDate() + 1);
        ctrl.initalEndDate = startDate.toISOString().split('T')[0];
        ctrl.currentMessage.endDate = null;
        console.log(ctrl.initalEndDate);
    };
    function resetCurrentMessage() {
        ctrl.messages.selected = undefined;
        ctrl.currentMessage = new broadcast_message_1["default"](ctrl.group.list);
    }
    function toggleGroupCheckboxes() {
        ctrl.currentMessage.onChangeEveryoneCanSee();
    }
    function initData() {
        var ADMIN_GROUPNAME = 'administrators';
        ctrl.initialStartDate = new Date().toISOString().split('T')[0];
        ctrl.smartorgApi
            .getListOfGroups()
            .then(function (response) {
            ctrl.group.list = response
                .filter(function (item) { return item.groupname !== ADMIN_GROUPNAME; })
                .sort(function (a, b) {
                return a.groupname.toLowerCase() > b.groupname.toLowerCase();
            });
            toggleGroupCheckboxes();
            $timeout(getMessageList);
        })["catch"](function (err) {
            showAlert(ERROR_MESSAGE, 'Error ' + err.status, err);
        });
    }
    function getMessageList(resetNewMessage) {
        ctrl.isLoading = true;
        ctrl.smartorgApi.messaging
            .adminGetAllMessages()
            .then(function (response) {
            ctrl.isLoading = false;
            ctrl.messages.list = response.map(function (item) {
                if (item.isExpired && item.isActive) {
                    item.isActive = false;
                    updateMessageStatus(item, false);
                }
                var m = new broadcast_message_1["default"](ctrl.group.list);
                m.loadFromDbFormat(item);
                return m;
            });
            if (resetNewMessage) {
                resetCurrentMessage();
            }
            $timeout();
        })["catch"](function (err) {
            ctrl.isLoading = false;
            showAlert(ERROR_MESSAGE, 'Error ' + err.status, err);
        });
    }
    ctrl.checkValidation = function () {
        if (!ctrl.currentMessage.startDate || ctrl.currentMessage.startDate == null) {
            showAlert(ERROR_MESSAGE, 'Error', 'Please Select Start Date.');
            return false;
        }
        if (!ctrl.currentMessage.endDate || ctrl.currentMessage.endDate == null) {
            showAlert(ERROR_MESSAGE, 'Error', 'Please Select End Date.');
            return false;
        }
        if (ctrl.currentMessage.startDate > ctrl.currentMessage.endDate) {
            console.log('datesss!!');
            showAlert(ERROR_MESSAGE, 'Error', 'End Date must be greater than the Start Date.');
            return false;
        }
        return true;
    };
    function updateCookie() {
        var ids = $cookies.get(MESSAGE_COOKIE_KEY);
        if (!ids) {
            console.log('No cookie found');
            return;
        }
        var readMessages = decodeURIComponent(ids).split(':');
        var updatedMessages = readMessages.filter(function (id) { return id !== ctrl.currentMessage._id; });
        var updatedIds = updatedMessages.join(':');
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 365); // 1 year expiration
        $cookies.put(MESSAGE_COOKIE_KEY, encodeURIComponent(updatedIds), { expires: expireDate });
    }
    function saveMessageList() {
        if (!ctrl.checkValidation()) {
            return;
        }
        ctrl.isFormLoadading = true;
        var toSave = [ctrl.currentMessage.toDbFormat()];
        ctrl.smartorgApi.messaging
            .saveMessages(toSave)
            .then(function (response) {
            ctrl.isFormLoadading = false;
            if (ctrl.currentMessage._id) {
                // updateCookie();
                ctrl.messages.selected.loadFromDbFormat(response[0]);
                ctrl.currentMessage = angular.copy(ctrl.messages.selected);
                getMessageList(false);
            }
            else {
                var m = new broadcast_message_1["default"](ctrl.group.list);
                m.loadFromDbFormat(response[0]);
                ctrl.currentMessage = m;
                ctrl.messages.list.push(ctrl.currentMessage);
                resetCurrentMessage();
                getMessageList(true);
            }
            $timeout(function () {
                showAlert(SUCCESS_MESSAGE, 'Message Saved!', 'The message is saved successfully.');
            });
        })["catch"](function (err) {
            ctrl.isFormLoadading = false;
            showAlert(ERROR_MESSAGE, 'Error ' + err.status, err);
        });
    }
    function updateMessageStatus(message, isActive) {
        if (!message.isExpired) {
            ctrl.isFormLoadading = true;
        }
        ctrl.smartorgApi.messaging
            .updateMessageStatus(message._id, isActive)
            .then(function (response) {
            if (!message.isExpired) {
                ctrl.isFormLoadading = false;
                if (ctrl.currentMessage._id == message._id) {
                    ctrl.currentMessage.isActive = isActive;
                }
                $timeout(function () {
                    if (isActive) {
                        var formattedDate = new Date(message.endDate).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                        });
                        showAlert(SUCCESS_MESSAGE, 'Message Enabled!', "The message will expire on <b>" + formattedDate + "</b>.<br>Edit the dates to change the expiry.");
                    }
                    else {
                        showAlert(SUCCESS_MESSAGE, 'Message Disabled!', 'The message is now disabled.');
                    }
                });
            }
        })["catch"](function (err) {
            if (!message.isExpired) {
                ctrl.isFormLoadading = false;
            }
            showAlert(ERROR_MESSAGE, 'Error ' + err.status, err);
        });
    }
    function updateExpiryDates(message) {
        message.updateExpiry();
        $scope.$apply();
        var toSave = [message.toDbFormat()];
        ctrl.isFormLoadading = true;
        ctrl.smartorgApi.messaging
            .saveMessages(toSave)
            .then(function (response) {
            ctrl.isFormLoadading = false;
            if (ctrl.currentMessage._id == message._id) {
                ctrl.currentMessage.isActive = message.isActive;
                var today = new Date();
                ctrl.currentMessage.endDate.setDate(today.getDate() + 14);
                ctrl.currentMessage.startDate.setDate(today.getDate());
                ctrl.currentMessage = angular.copy(ctrl.currentMessage);
                $scope.$apply();
            }
            var formattedDate = new Date(message.endDate).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
            $timeout(function () {
                showAlert(SUCCESS_MESSAGE, 'Message Enabled!', "The message will expire on <b>" + formattedDate + "</b>.<br>Edit the dates to change the expiry.");
            });
        })["catch"](function (err) {
            ctrl.isFormLoadading = false;
            showAlert(ERROR_MESSAGE, 'Error ' + err.status, err);
        });
    }
    function deleteListOfMessages() {
        ctrl.isFormLoadading = true;
        ctrl.smartorgApi.messaging
            .deleteListOfMessages([ctrl.currentMessage._id])
            .then(function (response) {
            ctrl.isFormLoadading = false;
            if (response && !response[0].ok) {
                if (response.error) {
                    throw response.error;
                }
                else {
                    throw JSON.stringify(response);
                }
            }
            ctrl.messages.list = ctrl.messages.list.filter(function (m) { return m._id !== ctrl.messages.selected._id; });
            resetCurrentMessage();
            toggleGroupCheckboxes();
            $timeout(function () {
                showAlert(SUCCESS_MESSAGE, 'Message Deleted!', 'The message is deleted successfully.');
            });
        })["catch"](function (err) {
            ctrl.isFormLoadading = false;
            showAlert(ERROR_MESSAGE, 'Error ' + err.status, err);
        });
    }
    ctrl.funcs = {
        back: function () {
            $scope.$emit('workbench:back');
        },
        loadMessages: function () {
            initData();
        },
        checkEveryone: function () {
            toggleGroupCheckboxes();
        },
        checkGroup: function () {
            ctrl.currentMessage.onChangeGroupState();
        },
        add: function () {
            resetCurrentMessage();
            toggleGroupCheckboxes();
        },
        "delete": function () {
            bootbox.dialog({
                message: 'Delete message <b>' + ctrl.currentMessage.title + '?</b>',
                title: 'Confirm Deletion',
                buttons: {
                    confirm: {
                        label: 'Delete',
                        className: 'btn-danger',
                        callback: function () {
                            deleteListOfMessages();
                        }
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-primary'
                    }
                }
            });
        },
        expiryModal: function (message) {
            bootbox.dialog({
                message: 'This message is expired. Enable if from today for two weeks?',
                title: 'Message Expired!',
                buttons: {
                    confirm: {
                        label: 'Update',
                        className: 'btn-danger',
                        callback: function () {
                            console.log(message);
                            updateExpiryDates(message);
                        }
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-primary',
                        callback: function () {
                            message.isActive = false;
                            console.log('false');
                            $scope.$apply();
                        }
                    }
                },
                onEscape: function () {
                    message.isActive = false;
                    console.log('escape');
                    $scope.$apply();
                }
            });
        },
        selectMessage: function (m) {
            ctrl.messages.selected = m;
            ctrl.currentMessage = angular.copy(ctrl.messages.selected);
        },
        onToggleMessage: function (message, event) {
            console.log(message);
            // event.stopPropagation();
            if (message.isExpired) {
                ctrl.funcs.expiryModal(message);
            }
            else {
                updateMessageStatus(message, message.isActive);
            }
        },
        save: function () {
            saveMessageList();
        }
    };
}
angular.module('smartorg.r6.mgmts.broadcastMessage', []).component('broadcastMessageManager', {
    template: require('../../template/template.html'),
    controller: BroadcastMessageContrller,
    bindings: {
        smartorgApi: '<',
        showAlert: '&'
    }
});
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.broadcastMessage';
//# sourceMappingURL=component.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/broadcast-messages/app/js/plumbing/component.js